import FrontBusiness from "@/business/FrontBusiness.js";
import VueBusiness from "@/business/VueBusiness.js";
import CachedApi from "@/commons/CachedApi.js";
import Http from "@/commons/Http";

const path = 'api/configuracao';

export default {

  async get(){
    return Http.get(`${path}`).catch(e => {
      FrontBusiness.showError('', e.message);
      return {};
    });
  },

  async getResumo(){
    return CachedApi.getCached('resumo-config', async () => {
      return Http.get(`${path}/resumo?c=${window.server.SLUG}`);
    });
  },

  async update(dto){
    return Http.post(`${path}`, dto);
  },

  /**
   * Catálogo da configuração de caixa das letras dos campos extraídos pela IA: quais campos são
   * configuráveis e quais estados existem. Vem do backend porque é ele quem aplica a transformação;
   * uma lista escrita aqui divergiria do que ele reconhece sem ninguém notar.
   */
  async getCaixaCamposIa(){
    return CachedApi.getCached('odin-caixa-campos', async () => {
      return Http.get(`${path}/odin/caixa-campos`);
    });
  },

  /**
   * Catálogo dos campos do indicador real que o cartório pode declarar protegidos na Análise de
   * Matrícula. Vem do backend pelo mesmo motivo do catálogo acima: é ele que aplica a proteção, e
   * uma lista escrita aqui ofereceria campo que a aprovação não sabe proteger.
   */
  async getCamposProtegiveisIa(){
    return CachedApi.getCached('odin-campos-protegiveis', async () => {
      return Http.get(`${path}/odin/campos-protegiveis`);
    });
  },

  async updateCartorio(dto){ return Http.post(`${path}/adm/cartorio`, dto); },
  async updateEmail(dto){ return Http.post(`${path}/adm/email`, dto); },
  async updateSelo(dto){ return Http.post(`${path}/adm/selo`, dto); },
  async updateIndisponibilidade(dto){ return Http.post(`${path}/adm/indisponibilidade`, dto); },
  async updateNotaFiscal(dto){ return Http.post(`${path}/adm/nota-fiscal`, dto); },
  async updateExigencia(dto){ return Http.post(`${path}/adm/exigencia`, dto); },
  async updateAguardandoPagamento(dto){ return Http.post(`${path}/adm/aguardando-pagamento`, dto); },
  async updateSite(dto){ return Http.post(`${path}/adm/site`, dto); },
  async updateSee(dto){ return Http.post(`${path}/adm/see`, dto); },
  async updateCentrais(dto){ return Http.post(`${path}/adm/centrais`, dto); },
  async updateEIntimacaoCentral(dto){ return Http.post(`${path}/adm/e-intimacao-central`, dto); },
  async updateAtendimento(dto){ return Http.post(`${path}/adm/atendimento`, dto); },
  async updateFinanceiro(dto){ return Http.post(`${path}/adm/financeiro`, dto); },
  async updatePagamento(dto){ return Http.post(`${path}/adm/pagamento`, dto); },
  async updateModelos(dto){ return Http.post(`${path}/adm/modelos`, dto); },
  async updatePeer(dto){ return Http.post(`${path}/adm/peer`, dto); },
  async updateLivros(dto){ return Http.post(`${path}/adm/livros`, dto); },
  async updateGeral(dto){ return Http.post(`${path}/adm/geral`, dto); },
  async updateOutras(dto){ return Http.post(`${path}/adm/outras`, dto); },
  async updateOdin(dto){ return Http.post(`${path}/adm/odin`, dto); },
  async previewTimbre(dto){ return Http.post(`${path}/adm/modelos/timbre/preview`, dto, { responseType: 'blob' }); },

  async updateTabelionato(form) {
    const dto = {
      tabelionato: form.tabelionato,
      livros: form.livros
    };
    return Http.post('/api/configuracao/adm/tabelionato', dto);
  },

  async alterarExpiracaoAcessoVHL(data) {
    return Http.post(`${path}/alterar-expiracao-vhl/${data}`);
  },

  async salvarFrasesLivro(dto){
    return Http.post(`${path}/salvar-frases-livro`, dto);
  },

  async atualizarFrasesLivro(id, dto){
    return Http.post(`${path}/atualizar-frases-livro/${id}`, dto);
  },

  async deletarFrasesLivro(id){
    return Http.delete(`${path}/deletar-frases-livro/${id}`);
  },

  async paginationV2(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/frases/pagination?sort=${sort || 'fl.cadastro'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async getConfiguracoesAcompanhamentoOnline(){
    return Http.get(`${path}/configuracoes-acompanhamento-online`);
  },

  async getLstBancoEmissor(){
    return Http.get(`${path}/banco-emissor`);
  },

  async getBancoEmissor(id){
    return Http.get(`${path}/banco-emissor/${id}`);
  },

  async getFrasesLivroProtocolo(id){
    return Http.get(`${path}/frases-livro-protocolo/${id}`);
  },

  async moduloNotaFiscalAtivo(){
    return VueBusiness.getVueRoot().config?.notaFiscal?.habilitada;
    // return Http.get(`${path}/modulo-nota-fiscal-ativo`)
  },

  async getLstTipoSelecaoIndicadorPessoal(){
    return Http.get(`${path}/tipo-selecao-indicador`);
  },

  async getLstApresentantes(){
    return Http.get(`${path}/apresentantes`);
  },

  async testarEnvioEmail(email){
    return Http.post(`${path}/testar-email`, email, {
      headers: { 'Content-Type': 'text/plain' }
    });
  },

  async getUltimaData(modulo) {
    return Http.get(`${path}/ultimaAtualizacao/${modulo}`);
  },

  async testarEnvioWhats(telefone){
    return Http.post(`${path}/whatsapp/test?telefone=${encodeURIComponent(telefone)}`);
  },

  async testarAssinadorOnr(){
    return Http.post(`${path}/testar-assinatura-onr`);
  },

  async saveLogoLivroProtocolo(logoLivroProtocolo) {
    return Http.post(`${path}/logo`, logoLivroProtocolo);
  },

  async deleteLogoLivroProtocolo() {
    return Http.delete(`${path}/logo`);
  },

  async getEnums() {
    return Http.get(`${path}/enums`);
  },

  async getLogoLivroProtocolo(cache = true) {
    let url = `${path}/public/logo${!cache ? `?clear=${Date.now()}` : ''}`;
    let logoLivroProtocolo = await Http.get(url, {cache : cache})
      .catch(() => null);
    return logoLivroProtocolo?.length > 1 ? `${window.server.API}/${url}`: null;
  },

  getContratoArisp(){
    return {
      tipoDocumento: [
        { id: 1, nome: "Escritura Pública"},
        { id: 2, nome: "Instrumento Particular"},
        { id: 4, nome: "Instrumento Particular com força de Escritura Pública"},
        { id: 6, nome: "Instrumento Particular de Cancelamento de Garantias"},
        { id: 5, nome: "Ordens Judiciais e Administrativas"},
        { id: 7, nome: "Requerimento Averbação"},
        { id: 8, nome: "Título de Crédito"},
        { id: 9, nome: "Parcelamento do Solo/Loteamento"},
        { id: 10, nome: "Incorporação/Especificação"},
        { id: 11, nome: "Retificação Administrativa"},
        { id: 12, nome: "Usucapião Extrajudicial e Judicial"},
        { id: 13, nome: "Reurb"}
      ],
      certidoes: [
        { id: 3, nome: "Matrícula do Imóvel"},
        { id: 4, nome: "Transcrição"},
        { id: 6, nome: "Ônus e Alienações"},
        { id: 2, nome: "Vintenária"},
        { id: 1, nome: "Propriedade/Negativa de Propriedade"},
        { id: 7, nome: "Documento Arquivado"},
        { id: 5, nome: "Pacto Antenupcial"},
        { id: 8, nome: "Convenção de Condomínio"},
        { id: 9, nome: "Livro 3 - Garantias"},
        { id: 10, nome: "Outros Registros Livro 3 - Auxiliar"},
        { id: 12, nome: "Inteiro Teor, Ônus e Ações"},
        { id: 13, nome: "Por Quesito"},
        { id: 14, nome: "Negativa de Penhor"},
        { id: 15, nome: "Ônus Reais e Ações Reipersecutórias"},
        { id: 16, nome: "Usucapião"},
        { id: 17, nome: "Propriedade, Ônus E Alienações"},
        { id: 18, nome: "Cadeia Dominial (Filiação Até Origem)"},
        { id: 19, nome: "Ações Reipersecutórias"},
        { id: 20, nome: "Ônus Reais"},
        { id: 21, nome: "Certidão da Situação Jurídica Atualizada do Imóvel"},
        { id: 22, nome: "Certidão Agronegócio"},
      ],
      tipoPesquisaCertidao:[
        { id: 4, nome: "Nº de Matrícula"},
        { id: 5, nome: "Nº de Transcrição"},
        { id: 6, nome: "Nome da Pessoa Física ou Jurídica"},
        { id: 7, nome: "Nº de Registro"},
        { id: 8, nome: "Nome dos Pactuantes"},
        { id: 9, nome: "Endereço"},
        { id: 10, nome: "Nº do Protocolo"},
        { id: 11, nome: "Nº do Registro do Livro 3"},
        { id: 12, nome: "Nome do Condomínio"},
        { id: 13, nome: "Nº de Matrícula com Complemento"},
        { id: 14, nome: "Nº de Transcrição com Complemento"},
      ]
    }
  },

  getPeerBancos(){
    return {
      papeis: [
        { id: 1,	nome : 'Adquirente' },
        { id: 2,	nome : 'Avalista' },
        { id: 3,	nome : 'Credor' },
        { id: 4,	nome : 'Depositário' },
        { id: 5,	nome : 'Devedor' },
        { id: 6,	nome : 'Incorporado' },
        { id: 7,	nome : 'Incorporador' },
        { id: 8,	nome : 'Interessado' },
        { id: 9,	nome : 'Interveniente' },
        { id: 10,	nome : 'Proprietário' },
        { id: 11,	nome : 'Requerente' },
        { id: 12,	nome : 'Transmitente' },
        { id: 13,	nome : 'Anuente' },
        { id: 14,	nome : 'Representante Credor' },
        { id: 16,	nome : 'Emitente' },
        { id: 17,	nome : 'Fiel Depositário' },
        { id: 18,	nome : 'Garantidor' },
        { id: 19,	nome : 'Cedente' },
        { id: 20,	nome : 'Cessionário' },
        { id: 21,	nome : 'Fiador' }
      ],

      atos : [
        {id : 1, nome :	'Compra e Venda'},
        {id : 2, nome :	'Hipoteca'},
        {id : 3, nome :	'Alienação Fiduciária'},
        {id : 4, nome :	'Portabilidade'},
        {id : 5, nome :	'Compra e Venda Alienação'},
        {id : 6, nome :	'Averbação de CCI'},
        {id : 7, nome :	'Compra e Venda Alienação CCB'},
        {id : 8, nome :	'Abertura de Limite de Crédito'},
        {id : 9, nome :	'Compromisso de Venda e Compra'},
        {id : 10, nome : 'Doação'},
        {id : 11, nome : 'Usufruto'},
        {id : 12, nome : 'Inventário'},
        {id : 13, nome : 'Part. Separação/Divórcio'},
        {id : 14, nome : 'Dação em pagamento'},
        {id : 15, nome : 'Permuta'},
        {id : 16, nome : 'Conferência de bens'},
        {id : 17, nome : 'Bem de família'},
        {id : 18, nome : 'Aditamento'},
        {id : 19, nome : 'Abertura de Limite de Crédito CPR'},
        {id : 101, nome : 'Cessão de Direitos'},
        {id: 200, nome: 'Inscrição Imobiliária'},
        {id: 201, nome: 'Pacto Antenupcial'},
        {id: 202, nome: 'Cancelamento de Alienação Fiduciária'},
        {id: 203, nome: 'Casamento (Comunhão Parcial de Bens)'},
        {id: 204, nome: 'Casamento (Comunhão Universal de Bens)'},
        {id: 205, nome: 'Casamento (Separação de Bens)'},
        {id: 206, nome: 'Separação Obrigatória de Bens'},
        {id: 207, nome: 'Casamento'},
        {id: 208, nome: 'Divórcio'},
        {id: 209, nome: 'Alteração de Estado Civil'},
        {id: 210, nome: 'Alienação Fiduciária - Programa Casa Verde e Amarela'},
        {id: 211, nome: 'Compra e Venda - Programa Casa Verde e Amarela'},
        {id: 212, nome: 'Cancelamento de Hipoteca'},
        {id: 213, nome: 'Alteração de Razão Social'},
        {id: 214, nome: 'Cancelamento de Cédula de Crédito Imobiliário'},
        {id: 215, nome: 'Usufruto Vitalício'},
        {id: 216, nome: 'Cláusula Resolutiva'},
        {id: 217, nome: 'Cláusula de Reversão'},
        {id: 218, nome: 'Cancelamento de Cessão de Direitos Creditórios'},
        {id: 219, nome: 'Cancelamento de Cessão Fiduciária de Direitos Creditórios'},
        {id: 220, nome: 'Cláusulas de Inalienabilidade, Impenhorabilidade e Incomunicabilidade'},
        {id: 221, nome: 'Cessão de Direito de Enfiteuse'}
      ],

      naturezasOnr: {
        instituicaoFinanceira: [
          {id: 1, nome: 'Instrumento Particular com Força de Escritura Pública'},
          {id: 3, nome: 'Instrumento Particular'},
        ],

        tabelionato: [
          {id: 4, nome: 'Escritura Pública'},
        ]
      },

      naturezasFinanciamento: {
        instituicaoFinanceira: [
          {id: 1, nome: 'Âmbito do SFH'},
          {id: 2, nome: 'Fora do âmbito do SFH'},
          {id: 3, nome: 'PMCMV'},
          {id: 4, nome: 'SFI'},
          {id: 5, nome: 'Outro'},
          {id: 6, nome: 'Programa Casa Verde Amarela'},
          {id: 7, nome: 'Crédito com garantia de imóvel'},
          {id: 8, nome: 'FGTS Procotista'},
        ],

        tabelionato: [
          {id: 1, nome: 'SFH taxa tabelada'},
          {id: 2, nome: 'SFH taxa de mercado'},
          {id: 3, nome: 'PMCMV'},
          {id: 4, nome: 'SFI'},
          {id: 5, nome: 'Outro'},
        ]
      },

      naturezas : [
        // {id: 1, nome: 'Instrumento Particular com Força de Escritura Pública'},
        // {id: 3, nome: 'Instrumento Particular'},
        // {id: 4, nome: 'Escritura Pública'},

        // {id: 1, nome: 'Instrumento Particular com Força de Escritura Pública'},
        // {id: 2, nome: 'SFH taxa de mercado'},
        // {id: 3, nome: 'Instrumento Particular'},
        // {id: 4, nome: 'SFI'},
        // {id: 5, nome: 'Outro Enquandramento de Financiamento'},

        {id: 101, nome: 'Instrumento Particular'},
        {id: 102, nome: 'Cédula de Crédito Imobiliário'},
        {id: 103, nome: 'Cédula de Crédito Bancário'},
        {id: 104, nome: 'Escritura Pública'},

        {id: 201, nome: 'Mandado/Decisão Judicial'},
        {id: 202, nome: 'Carta de Arrematação/Adjudicação'},
        {id: 203, nome: 'Formal de Partilha'},
        {id: 204, nome: 'Usucapião'},
        {id: 205, nome: 'Contrato de Financiamento'},
        {id: 206, nome: 'Contrato de Alienação Fiduciária'},
        {id: 207, nome: 'Ofício Judicial/Administrativo'},
        {id: 208, nome: 'Doação'},
        {id: 209, nome: 'Cessão de Direitos'},
        {id: 210, nome: 'Permuta'},
        {id: 211, nome: 'Dação em Pagamento'},
        {id: 212, nome: 'Incorporação/Instituição Imobiliária'},
        {id: 213, nome: 'Retificação/Regularização de Área'},
        {id: 214, nome: 'Georreferenciamento'},
        {id: 215, nome: 'Averbação de Construção'},
        {id: 216, nome: 'Cancelamento de Ônus/Gravame'},
        {id: 217, nome: 'Indisponibilidade de Bens'},
        {id: 218, nome: 'Cédula de Crédito Rural'},
        {id: 219, nome: 'Cédula de Crédito Comercial'},
        {id: 220, nome: 'Cédula de Crédito Industrial'},
        {id: 221, nome: 'Cédula de Crédito à Exportação'},
        {id: 222, nome: 'Aditamento/Rerratificação Contratual'},
        {id: 223, nome: 'Notificação'},
        {id: 224, nome: 'Requerimento Administrativo'},
        {id: 999, nome: 'Outros'}
      ],

      documentos : [
        {id : 1, nome: 'Instrumento Particular'},
        {id : 2, nome: 'Cédula de Crédito Imobiliário'},
        {id : 3, nome: 'Cédula de Crédito Bancário'},
        {id : 4, nome: 'Escritura pública'},
      ],

      indices : [
        {id : 'DATAINSTRUMENTO', nome : 'DATAINSTRUMENTO'},
        {id : 'NUMCONTRATO', nome : 'NUMCONTRATO'},
        {id : 'LIVRO', nome : 'LIVRO'},
        {id : 'FOLHA', nome : 'FOLHA'},

        {id : 'CEDULA.TIPOCEDULA', nome : 'CEDULA.TIPOCEDULA'},
        {id : 'CEDULA.TIPO', nome : 'CEDULA.TIPO'},
        {id : 'CEDULA.NUMERO', nome : 'CEDULA.NUMERO'},
        {id : 'CEDULA.FRACAO', nome : 'CEDULA.FRACAO'},
        {id : 'CEDULA.SERIE', nome : 'CEDULA.SERIE'},
        {id : 'CEDULA.ESPECIE', nome : 'CEDULA.ESPECIE'},
        {id : 'CEDULA.CUSTODIANTE_EMISSOR', nome : 'CEDULA.CUSTODIANTE_EMISSOR'},
        {id : 'CEDULA.DATA', nome : 'CEDULA.DATA'},

        {id : 'IMPOSTOTRANSMISSAO.ISENCAO', nome : 'IMPOSTOTRANSMISSAO.ISENCAO'},
        {id : 'IMPOSTOTRANSMISSAO.INSCRICAO', nome : 'IMPOSTOTRANSMISSAO.INSCRICAO'},
        {id : 'IMPOSTOTRANSMISSAO.GUIA', nome : 'IMPOSTOTRANSMISSAO.GUIA'},
        {id : 'IMPOSTOTRANSMISSAO.VALOR', nome : 'IMPOSTOTRANSMISSAO.VALOR'},

        {id : 'NEGOCIO.TIPOATO', nome : 'NEGOCIO.TIPOATO'},
        {id : 'NEGOCIO.VALORLEILAO', nome : 'NEGOCIO.VALORLEILAO'},
        {id : 'NEGOCIO.RECURSOSPROPRIOS', nome : 'NEGOCIO.RECURSOSPROPRIOS'},
        {id : 'NEGOCIO.OUTROSRECURSOS', nome : 'NEGOCIO.OUTROSRECURSOS'},
        {id : 'NEGOCIO.PRIMEIRAAQUISICAO', nome : 'NEGOCIO.PRIMEIRAAQUISICAO'},
        {id : 'NEGOCIO.OBSERVACOESGERAIS', nome : 'NEGOCIO.OBSERVACOESGERAIS'},

        {id : 'FINANCIAMENTO.VALORFINANCIAMENTO', nome : 'FINANCIAMENTO.VALORFINANCIAMENTO'},
        {id : 'FINANCIAMENTO.VALORAVALIACAO', nome : 'FINANCIAMENTO.VALORAVALIACAO'},
        {id : 'FINANCIAMENTO.VALORLEILAO', nome : 'FINANCIAMENTO.VALORLEILAO'},
        {id : 'FINANCIAMENTO.PRAZOCARENCIA', nome : 'FINANCIAMENTO.PRAZOCARENCIA'},
        {id : 'FINANCIAMENTO.ENQUADRAMENTOFINANCIAMENTO', nome : 'FINANCIAMENTO.ENQUADRAMENTOFINANCIAMENTO'},
        {id : 'FINANCIAMENTO.SISTEMAAMORTIZACAO', nome : 'FINANCIAMENTO.SISTEMAAMORTIZACAO'},
        {id : 'FINANCIAMENTO.PRAZOAMORTIZACAO', nome : 'FINANCIAMENTO.PRAZOAMORTIZACAO'},
        {id : 'FINANCIAMENTO.ORIGEMRECURSOS', nome : 'FINANCIAMENTO.ORIGEMRECURSOS'},
        {id : 'FINANCIAMENTO.JUROSANUALNOMINAL', nome : 'FINANCIAMENTO.JUROSANUALNOMINAL'},
        {id : 'FINANCIAMENTO.JUROSANUALEFETIVO', nome : 'FINANCIAMENTO.JUROSANUALEFETIVO'},
        {id : 'FINANCIAMENTO.JUROSMENSALNOMINAL', nome : 'FINANCIAMENTO.JUROSMENSALNOMINAL'},
        {id : 'FINANCIAMENTO.JUROSMENSALEFETIVO', nome : 'FINANCIAMENTO.JUROSMENSALEFETIVO'},
        {id : 'FINANCIAMENTO.DATAPRIMEIRAPARCELA', nome : 'FINANCIAMENTO.DATAPRIMEIRAPARCELA'},
        {id : 'FINANCIAMENTO.VALORPRIMEIRAPARCELA', nome : 'FINANCIAMENTO.VALORPRIMEIRAPARCELA'},
        {id : 'FINANCIAMENTO.DESTFINANCIAMENTO', nome : 'FINANCIAMENTO.DESTFINANCIAMENTO'},
        {id : 'FINANCIAMENTO.FORMADEPAGAMENTO', nome : 'FINANCIAMENTO.FORMADEPAGAMENTO'},
        {id : 'FINANCIAMENTO.VALORTOTALCREDITO', nome : 'FINANCIAMENTO.VALORTOTALCREDITO'},
        {id : 'FINANCIAMENTO.TAXAMAXIMAJUROS', nome : 'FINANCIAMENTO.TAXAMAXIMAJUROS'},
        {id : 'FINANCIAMENTO.TAXAMINIMAJUROS', nome : 'FINANCIAMENTO.TAXAMINIMAJUROS'},
        {id : 'FINANCIAMENTO.PRAZODEVIGENCIA', nome : 'FINANCIAMENTO.PRAZODEVIGENCIA'},
        {id : 'FINANCIAMENTO.VENCIMENTOANTECIPADO', nome : 'FINANCIAMENTO.VENCIMENTOANTECIPADO'},
        {id : 'FINANCIAMENTO.INFORMACAOGERAIS', nome : 'FINANCIAMENTO.INFORMACAOGERAIS'}
      ]
    }
  },
  getAcompanhamentoOnline(){
    return [
      {id: 'TODAS_EXIGENCIAS', nome: 'Todas as exigências do protocolo atual'},
      {id: 'ULTIMA_EXIGENCIA', nome: 'Apenas a última exigência do protocolo atual'},
      {id: 'TODAS_EXIGENCIAS_REPROTOCOLO', nome: 'Todas as exigências do reprotocolo'}
    ]
  }
}
